<div class="modal-content">
      <div class="modal-header bg-blue4">
        <h4 class="modal-title white text-bold-600" id="myModalLabel34">Actualizar contraseña</h4>
      </div>
      <form [formGroup]="updatePasswordForm" (ngSubmit)="tryUpdate()">
        <div class="modal-body">
          <div class="alert alert-warning" role="alert">
            <span class="text-bold-600">Por seguridad,</span> te sugerimos actualizar tu contraseña.
          </div>
          <p class="font-medium-1">Al momento de generar tu cuenta utilizamos información que es pública y puede ser de fácil acceso para los demás. 
          Por ello te aconsejamos que crees una nueva contraseña para acceder al portal.</p>
          <hr>
          <label>Contraseña: <span class="requiredAttribute warning">*</span> </label>
          <div class="form-group position-relative has-icon-left">
            <div><input type="password" autocomplete="new-password" placeholder="Nueva contraseña" formControlName="password" class="form-control"></div>
            <div class="form-control-position">
              <i class="la la-lock font-medium-3 line-height-1 text-muted icon-align"></i>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="dismiss()" class="btn btn-outline-dark"
            >Omitir por ahora</button>
          <button type="submit" class="btn btn-navy" >Actualizar Contraseña</button>
        </div>
      </form>
</div>